import { create } from '~/utils/store/createStore';

interface ScheduleDemoBannerStore {
  isVisible: boolean;
  showBanner: () => void;
  hideBanner: () => void;
}

export const useScheduleDemoBanner = create<ScheduleDemoBannerStore>(set => ({
  isVisible: false,
  showBanner: () => set({ isVisible: true }),
  hideBanner: () => set({ isVisible: false }),
}));
